import { ClientRepo as clientRepo } from "./client.repo";

class ClientsController implements angular.IOnInit {
  static $inject = [
    "clientRepo",
    "$scope",
    "$cookies",
    "$state",
    "ModalService",
    "$timeout",
  ];

  public username: any;
  public searchTerm: any;
  public searchColumn: any;
  public orderColumn: any;
  public orderDirection: any;
  public gridOptions: any;
  public page: any;
  public itemsPerPage: any;
  public isDisplayingAllClients: boolean;
  public isLoading: boolean = false;
  public displayActive: boolean = true;

  private selectedInvestmentOfficers: any;
  private InvestmentOfficerOptions: any;

  private selectedPortfolioManagers: any;
  private PortfolioManagerOptions: any;

  /** @ngInject */
  constructor(
    private clientRepo: clientRepo,
    private $scope: angular.IScope,
    private $cookies: angular.cookies.ICookiesService,
    private $state: angular.ui.IStateService,
    private ModalService: any,
    private $timeout: angular.ITimeoutService
  ) {
    let that = this;
    this.$timeout(function () {
      if (!localStorage.getItem("itemsPerPage")) {
        that.itemsPerPage = 10;
        localStorage.setItem("itemsPerPage", that.itemsPerPage);
      }
      if (!localStorage.getItem("currentPage")) {
        that.page = 1;
        localStorage.setItem("currentPage", that.page);
      }

      if (!localStorage.getItem("searchTerm")) {
        that.searchTerm = "";
        localStorage.setItem("searchTerm", that.searchTerm);
      }

      that.page = localStorage.getItem("currentPage");
      that.gridOptions.grid.paginationOptions.currentPage = that.page;

      that.itemsPerPage = localStorage.getItem("itemsPerPage");
      that.gridOptions.grid.paginationOptions.itemsPerPage = that.itemsPerPage;

      that.searchTerm = localStorage.getItem("searchTerm");

      that.tableSearchOrFilter(false);
    }, 1000);
  }

  $onInit() {
    // set the grid paging, pageNumber and displayAllClients flag on the localStorage
    if (localStorage.getItem("isDisplayingAllClients") === "true") {
      this.isDisplayingAllClients = true;
    } else {
      this.isDisplayingAllClients = false;
    }

    this.$scope["actions"] = {};
    this.gridOptions = this.$scope["options"] = {
      urlSync: true,
      data: [],
      sort: {
        predicate: "name",
        direction: "asc",
      },
      getData: this.retrieveClientData.bind(this),
    };
  }

  private retrieveClientData(params, callback) {
    // console.log("called retrieveClientData")
    let that = this;
    if (!localStorage.getItem("itemsPerPage")) {
      that.itemsPerPage = 10;
      localStorage.setItem("itemsPerPage", that.itemsPerPage);
    }
    if (!localStorage.getItem("currentPage")) {
      that.page = 1;
      localStorage.setItem("currentPage", that.page);
    }
    if (!localStorage.getItem("searchTerm")) {
      that.searchTerm = "";
      localStorage.setItem("searchTerm", that.searchTerm);
    }

    that.page = localStorage.getItem("currentPage");
    that.gridOptions.grid.paginationOptions.currentPage = that.page;

    that.itemsPerPage = localStorage.getItem("itemsPerPage");
    that.gridOptions.grid.paginationOptions.itemsPerPage = that.itemsPerPage;

    that.searchTerm = localStorage.getItem("searchTerm");

    this.orderColumn = this.gridOptions.grid.sortOptions.predicate;
    this.orderDirection = this.gridOptions.grid.sortOptions.direction;

    this.clientRepo
      .getClients(
        this.page,
        this.itemsPerPage,
        this.searchTerm,
        this.searchColumn,
        this.orderColumn,
        this.orderDirection,
        this.isDisplayingAllClients,
        this.selectedInvestmentOfficers,
        this.selectedPortfolioManagers,
        this.displayActive
      )
      .then((val) => {
        let clientList: any = val.data;
        let data = this.processResults(val);
        callback(data, clientList.count);
      });
  }

  private processResults(results) {
    let clientList: any = results.data;
    let data = [];
    this.setOfficerAndManagerFilterOptions(results);

    // Process the client data
    for (var c of clientList.results) {
      let clientItem = {
        clientNumber: c.clientNumber,
        name: c.name,
        status: c.status,
        owner: c.accountOwner,
        manager: c.relationshipManager,
        link: null,
      };

      if (c.crM_ContactId) {
        clientItem.link = `https://confident.api.crm4.dynamics.com/main.aspx?etc=2&id=${c.crM_ContactId}&newWindow=true&pagetype=entityrecord`;
      } else {
        clientItem.link = `https://confident.api.crm4.dynamics.com/main.aspx?etc=1&id=${c.crM_AccountId}&newWindow=true&pagetype=entityrecord`;
      }

      data.push(clientItem);
    }

    return data;
  }

  public refresh() {
    this.isLoading = true;
    this.page = this.gridOptions.grid.paginationOptions.currentPage;
    this.itemsPerPage = this.gridOptions.grid.paginationOptions.itemsPerPage;
    this.orderColumn = this.gridOptions.grid.sortOptions.predicate;
    this.orderDirection = this.gridOptions.grid.sortOptions.direction;

    this.clientRepo
      .refreshClients(
        this.page,
        this.itemsPerPage,
        this.searchTerm,
        this.searchColumn,
        this.orderColumn,
        this.orderDirection,
        this.isDisplayingAllClients,
        this.selectedInvestmentOfficers,
        this.selectedPortfolioManagers,
        this.displayActive
      )
      .then((val: angular.IHttpPromiseCallbackArg<any>) => {
        this.gridOptions.grid.filtered = this.processResults(val);
        this.gridOptions.grid.paginationOptions.currentPage = 1;
        this.gridOptions.grid.paginationOptions.totalItems = val.data.count;
        this.isLoading = false;
      });
  }

  // Both the search and the filter on the page trigger this function to retrieve the correct list of clients:

  // Angular Data Grid (grid-data) does not do client side filtering if server-pagination="true".
  // Instead it tries to change the path by adding the selected items to be sent to the server for filtering.
  // The path it changes is not the path that we send, so the filter information is now being sent by us, using this function.
  public tableSearchOrFilter(isSearchOrFilter: boolean = false) {
    localStorage.setItem("searchTerm", this.searchTerm);
    // setting the page and item numbers to a default number because you can get stuck on a different page and results will not be shown.
    if (isSearchOrFilter) {
      this.page = 1;
      this.gridOptions.grid.paginationOptions.currentPage = this.page;
      this.itemsPerPage = this.gridOptions.grid.paginationOptions.itemsPerPage;
      this.orderColumn = this.gridOptions.grid.sortOptions.predicate;
      this.orderDirection = this.gridOptions.grid.sortOptions.direction;
    } else {
      this.page = this.gridOptions.grid.paginationOptions.currentPage;
      this.itemsPerPage = this.gridOptions.grid.paginationOptions.itemsPerPage;
      this.orderColumn = this.gridOptions.grid.sortOptions.predicate;
      this.orderDirection = this.gridOptions.grid.sortOptions.direction;
    }

    this.clientRepo
      .getClients(
        this.page,
        this.itemsPerPage,
        this.searchTerm,
        this.searchColumn,
        this.orderColumn,
        this.orderDirection,
        this.isDisplayingAllClients,
        this.selectedInvestmentOfficers,
        this.selectedPortfolioManagers,
        this.displayActive
      )
      .then((val: angular.IHttpPromiseCallbackArg<any>) => {
        if (val.data.results.length == 0) {
          // console.log(" this.gridOptions.grid.paginationOptions in table search or filter",  this.gridOptions.grid.paginationOptions)
          this.page = 1;
          this.gridOptions.grid.paginationOptions.currentPage = this.page;
          localStorage.setItem(
            "currentPage",
            this.gridOptions.grid.paginationOptions.currentPage
          );
          this.tableSearchOrFilter(false);
        } else {
          this.gridOptions.grid.filtered = this.processResults(val);
          this.gridOptions.grid.paginationOptions.totalItems = val.data.count;
        }
      });
  }

  // Set the InvestmentOfficerOptions and PortfolioManagerOptions so that we can populate the multi-selects in the table
  // with all the names of the investment officers and the portfolio managers:
  private setOfficerAndManagerFilterOptions(results) {
    this.InvestmentOfficerOptions = [];
    this.PortfolioManagerOptions = [];

    for (var name of results.data.investmentOfficerOptions) {
      if (name != null && name != "") {
        let investmentOfficerItem = {
          name: name,
        };
        this.InvestmentOfficerOptions.push(investmentOfficerItem);
      }
    }

    for (var name of results.data.portfolioManagerOptions) {
      if (name != null && name != "") {
        let portfolioManagerItem = {
          name: name,
        };
        this.PortfolioManagerOptions.push(portfolioManagerItem);
      }
    }
  }

  public getPortfolioManagerOptions(results) {
    return this.PortfolioManagerOptions;
  }

  public setSelectedFilters() {
    this.selectedInvestmentOfficers =
      this.gridOptions.grid.selectedInvestmentOfficers;
    this.selectedPortfolioManagers =
      this.gridOptions.grid.selectedPortfolioManagers;
  }

  public getInvestmentOfficerOptions(results) {
    return this.InvestmentOfficerOptions;
  }

  public linkProfiles(clientNumber: string) {
    this.ModalService.showModal({
      templateUrl: "./app/clients/modaltemplates/linkprofiles.html",
      controller: "LinkProfileController",
      inputs: {
        clientNumber: clientNumber,
      },
    }).then(function (modal) {
      modal.element.modal({
        backgroud: "static",
        keyboard: false,
      });
    });
  }

  public displayAllClients(displayAllClients: boolean) {
    localStorage.setItem(
      "isDisplayingAllClients",
      displayAllClients.toString()
    );
    this.tableSearchOrFilter(true);
  }

  public updatePageOptions() {
    // console.log("start", this.gridOptions.grid.paginationOptions)
    // console.log("start this.page", this.page)
    // console.log("start this.itemsPerPage", this.itemsPerPage)
    // console.log("called updatePageOptions ","localStorage.getItem('currentPage')" ,localStorage.getItem("currentPage") , "localStorage.getItem('itemsPerPage') ", localStorage.getItem('itemsPerPage'))
    if (
      localStorage.getItem("currentPage") ||
      localStorage.getItem("itemsPerPage")
    ) {
      localStorage.setItem(
        "currentPage",
        this.gridOptions.grid.paginationOptions.currentPage
      );
      localStorage.setItem(
        "itemsPerPage",
        this.gridOptions.grid.paginationOptions.itemsPerPage
      );
      this.page = localStorage.getItem("currentPage");
      this.gridOptions.grid.paginationOptions.currentPage = this.page;
      this.itemsPerPage = localStorage.getItem("itemsPerPage");
      this.gridOptions.grid.paginationOptions.itemsPerPage = this.itemsPerPage;
    } else {
      localStorage.setItem(
        "currentPage",
        this.gridOptions.grid.paginationOptions.currentPage
      );
      localStorage.setItem(
        "itemsPerPage",
        this.gridOptions.grid.paginationOptions.itemsPerPage
      );
    }

    // console.log(this.gridOptions.grid.paginationOptions)
    // console.log("this.page", this.page)
    // console.log("this.itemsPerPage", this.itemsPerPage)
  }

  public clearSearchTerm = () => {
    this.searchTerm = "";
    localStorage.setItem("searchTerm", this.searchTerm);
  };

  navigateToPortfolioManagement = (clientNumber) => {
    this.$state.go("root.portfolioManagement.clients.portfolio", {
      clientNumber,
    });
  };

  scrollToTopOfTable = () => {
    let table = document.querySelector("#clients-table");
    let tbody = table.querySelectorAll("tbody");
    tbody[0].scrollTop = 0;
  };
}

export const clients: angular.IComponentOptions = {
  template: require("./clients.html"),
  controller: ClientsController,
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.ts